<template>
    <v-dialog 
        v-model="showModal" 
        overlay-opacity="0.5"
        :persistent="persistente"
        @click:outside="clicAfuera"
        max-width="unset"
        content-class="auto-dialog"
        
    >
        <slot></slot>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            z_index: {
                type: Number,
                default: 1000
            },
            /**
             * Sin cierre por clic afuera ni por Escape (`v-dialog persistent`).
             * Lo pide el payload de `openModal` con `persistente: true`.
             */
            persistente: {
                type: Boolean,
                default: false
            }
        },
        emits: ['confirm', 'close'],

        data(){
            return {
                showModal : true,
            }
        },


        methods: {
            // `v-dialog persistent` igual emite `click:outside` (solo anima el
            // rebote): sin este control el modal se cerraría por el store.
            clicAfuera() {
                if (this.persistente) return;
                this.close();
            },
            close() {
                console.log("CLOSING MODAL FROM CUSTOM MODAL");
                this.showModal = false;
                this.$emit('close');
            }
        }
    }
</script>

<style >
    .auto-dialog {
        width: auto !important;
        max-width: fit-content !important;
    }
</style>